import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
import { getUpcomingTournaments } from '../../services/tournamentService';

// Live ticker at bottom of hero showing next tournament
const TournamentTicker = () => {
  const [tournament, setTournament] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await getUpcomingTournaments({ limit: 1 });
        if (mounted && res.success && res.data && res.data.length > 0) {
          const sorted = res.data.sort(
            (a, b) => new Date(a.start_date) - new Date(b.start_date)
          );
          setTournament(sorted[0]);
        }
      } catch (err) {
        console.error('Ticker load error:', err);
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (!tournament) return null;

  const date = new Date(tournament.start_date).toLocaleDateString('en-ZA', {
    day: 'numeric',
    month: 'short'
  });

  return (
    // Full-width wrapper prevents overflow; inner pill constrained
    <div className="absolute bottom-4 sm:bottom-6 left-0 right-0 z-20 px-4 pointer-events-none">
      <div className="max-w-3xl mx-auto pointer-events-auto">
        <Link
          to={`/tournaments/${tournament.id}`}
          className="group block w-full"
        >
          <div className="flex items-center gap-2 sm:gap-4 px-3 sm:px-6 py-2.5 sm:py-3 rounded-full backdrop-blur-md bg-black/40 border border-white/20 hover:bg-black/50 transition-all duration-300 shadow-2xl">
            <div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0">
              <span className="relative flex h-2 w-2 sm:h-2.5 sm:w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-fsgu-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 sm:h-2.5 sm:w-2.5 bg-fsgu-green-500"></span>
              </span>
              <span className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-fsgu-green-300 hidden sm:inline">
                Next
              </span>
            </div>

            <div className="h-4 w-px bg-white/20 hidden sm:block" />

            <div className="flex-1 min-w-0 flex items-center gap-2 sm:gap-3 text-white text-xs sm:text-sm">
              <span className="font-semibold truncate">
                {tournament.name || tournament.tournament_name}
              </span>
              <span className="hidden md:flex items-center gap-1 text-white/80 flex-shrink-0">
                <Calendar className="w-3.5 h-3.5" />
                {date}
              </span>
              {(tournament.venue || tournament.venue_name) && (
                <span className="hidden lg:flex items-center gap-1 text-white/80 flex-shrink-0">
                  <MapPin className="w-3.5 h-3.5" />
                  {tournament.venue || tournament.venue_name}
                </span>
              )}
            </div>

            <ArrowRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white/80 group-hover:translate-x-1 group-hover:text-white transition-all flex-shrink-0" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default TournamentTicker;